/**
 * Attivazione "façade" -> player al click.
 *
 * Al primo click sul poster costruisco il player giusto per il provider
 * e lo inserisco al posto della façade:
 * - youtube: iframe youtube-nocookie con i parametri;
 * - vimeo:   iframe player.vimeo;
 * - file:    <video> nativo.
 *
 * Prima del click non viene caricato nulla di terze parti. Su
 * pointerenter/touchstart faccio un preconnect al dominio del provider
 * per ridurre la latenza al momento del play.
 */

const PRECONNECT = {
  youtube: [
    "https://www.youtube-nocookie.com",
    "https://www.google.com",
    "https://i.ytimg.com",
    "https://fonts.gstatic.com",
  ],
  vimeo: ["https://player.vimeo.com", "https://i.vimeocdn.com", "https://f.vimeocdn.com"],
  file: [],
};

function addPreconnect(hosts) {
  hosts.forEach((href) => {
    if (document.head.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
      return;
    }
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = href;
    link.crossOrigin = "";
    document.head.appendChild(link);
  });
}

function buildYouTube(el) {
  const id = el.dataset.videoId;
  const params = new URLSearchParams();

  if (el.dataset.autoplay === "1") {
    params.set("autoplay", "1");
  }
  params.set("playsinline", "1");
  params.set("rel", "0");

  if (el.dataset.muted === "1") {
    params.set("mute", "1");
  }
  if (el.dataset.controls === "0") {
    params.set("controls", "0");
  }
  if (el.dataset.loop === "1") {
    params.set("loop", "1");
    params.set("playlist", id); // il loop di YouTube richiede playlist=id.
  }

  const iframe = document.createElement("iframe");
  iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params.toString()}`;
  iframe.allow =
    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share";
  iframe.allowFullscreen = true;
  iframe.title = el.getAttribute("aria-label") || "YouTube";
  return iframe;
}

function buildVimeo(el) {
  const id = el.dataset.videoId;
  const params = new URLSearchParams();

  if (el.dataset.autoplay === "1") {
    params.set("autoplay", "1");
  }
  if (el.dataset.muted === "1") {
    params.set("muted", "1");
  }
  if (el.dataset.loop === "1") {
    params.set("loop", "1");
  }
  if (el.dataset.controls === "0") {
    params.set("controls", "0");
  }

  const iframe = document.createElement("iframe");
  iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?${params.toString()}`;
  iframe.allow = "autoplay; fullscreen; picture-in-picture";
  iframe.allowFullscreen = true;
  iframe.title = el.getAttribute("aria-label") || "Vimeo";
  return iframe;
}

function buildFile(el) {
  const video = document.createElement("video");
  video.src = el.dataset.src;
  video.playsInline = true;
  if (el.dataset.controls !== "0") {
    video.controls = true;
  }
  if (el.dataset.loop === "1") {
    video.loop = true;
  }
  if (el.dataset.muted === "1") {
    video.muted = true;
  }
  if (el.dataset.autoplay === "1") {
    video.autoplay = true;
  }
  return video;
}

const BUILDERS = {
  youtube: buildYouTube,
  vimeo: buildVimeo,
  file: buildFile,
};

function activate(el) {
  if (el.classList.contains("is-activated")) {
    return;
  }

  const builder = BUILDERS[el.dataset.provider];
  if (!builder) {
    return;
  }

  const player = builder(el);
  el.classList.add("is-activated");
  el.appendChild(player);

  if (typeof player.focus === "function") {
    player.focus();
  }
  if (el.dataset.provider === "file" && typeof player.play === "function") {
    player.play().catch(() => {});
  }
}

function initPlayer(el) {
  const provider = el.dataset.provider;
  const hosts = PRECONNECT[provider] || [];

  const warm = () => addPreconnect(hosts);
  el.addEventListener("pointerenter", warm, { once: true });
  el.addEventListener("touchstart", warm, { once: true, passive: true });

  el.addEventListener("click", () => activate(el), { once: true });
}

document.querySelectorAll(".cappelli-video__player").forEach(initPlayer);
